import FirebaseFirestore from 'firebase/firestore';
import { OrderType, PaymentType } from '~/types/common';
import { ContainerInItem } from '~/types/store/container';
import { Coupon } from '~/types/coupon';
import {
  EnterpriseGroupBuyPaymentConsumerSubType,
  EnterpriseGroupBuyPaymentEnterpriseSubType,
} from './enterpriseGroupBuy';

export enum CartType {
  CART_PERSONAL = 'CART_PERSONAL',
  CART_GROUP = 'CART_GROUP',
}

export enum CartStatus {
  ACTIVE = 'CART_STATUS_ACTIVE',
  ORDERING = 'CART_STATUS_ORDERING',
  CANCELED = 'CART_STATUS_CANCELED',
  ORDERED = 'CART_STATUS_ORDERED',
}

export enum TaxType {
  PERSONAL = 'TAX_PERSONAL',
  COMPANY = 'TAX_COMPANY',
}

export type CartOption = {
  id: string;
  name: string;
  price: number;
  tax: number;
  containers: Array<ContainerInItem>;
};

export type CartModifier = {
  id: string;
  name: string;
  options: Array<CartOption>;
};

export type CartItem = {
  keyId: string; //在購物車內的唯一 id
  id: string;
  count: number;
  name: string;
  note: string;
  price: number;
  tax: number;
  modifiers: Array<CartModifier>;
  containers: Array<ContainerInItem>;
};

export type MemberStoreCart = {
  memberName: string;
  memberId: string;
  items: Array<CartItem>;
};

export type StoreOrderInCart = {
  storeId: string;
  name: string;
  items: Array<CartItem>;
  groupItems: Array<MemberStoreCart>;
};

export type TaxInfo = {
  title: string;
  invoice: string;
};

export type GroupHostInfo = {
  name: string;
  note: string;
};

export type CartLocation = {
  address: string;
  floor: string;
  note: string;
};

export type PickMealPoint = {
  id: string;
  name: string;
  address: string;
  geoPoint: FirebaseFirestore.GeoPoint;
};

export type PlatformCartInFirestore = {
  cartType: CartType;
  email: string;
  orders: Array<StoreOrderInCart>;
  orderType: OrderType;
  paymentType: PaymentType;
  pickMealAt: FirebaseFirestore.Timestamp | null;
  pickMealEnd: FirebaseFirestore.Timestamp | null;
  pickMealPoint: PickMealPoint | null;
  location: CartLocation | null;
  status: CartStatus;
  taxInfo: TaxInfo;
  taxType: TaxType;
  uid: string;
  groupHostInfo?: GroupHostInfo;
  coupon?: Coupon | null;
  campaignId: string;
};

export type PlatformCart = Omit<
  PlatformCartInFirestore,
  'pickMealAt' | 'pickMealEnd' | 'location'
> & {
  paymentSubType?:
    | EnterpriseGroupBuyPaymentEnterpriseSubType
    | EnterpriseGroupBuyPaymentConsumerSubType
    | null;
  pickMealAt: Date | null;
  pickMealEnd: Date | null;
};
